export default __webpack_public_path__ + "static/media/avatar18.3fc7edd4.png";